import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { ResultsService } from 'src/app/services/results.service';
import { faqDTO, CategoryDTO } from 'src/app/models/providersDTO';
import { $ } from 'protractor';

declare var jQuery: any


@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {
  faqlst: faqDTO[];
  catogrylst: CategoryDTO[];

  constructor(private router: Router, private formBuilder: FormBuilder, private resultservice: ResultsService) { }
  showMainContent: Boolean = true;
  colapse: boolean[] = [false];
  ngOnInit() {
    this.GetFaq();
    this.GetCategories();
  }
  ShowHideButton(id: any) {
    this.catogrylst.forEach(element => {
      if ('showMainContent' + element.CategoryId != id) {
        this.colapse['showMainContent' + element.CategoryId] = false;
      }
    })
    if (!this.colapse[id]) {
      this.colapse[id] = true;
    }
    else {
      this.colapse[id] = !this.colapse[id];
    }
    id = true;
    if (id == true) {
      id = false;
    }
    else {
      id = true;
    }
  }
  GetFaq() {
    this.resultservice.GetFaq().subscribe((data: any[]) => {
      this.faqlst = data;

    });
  }
  GetCategories() {
    this.resultservice.GetCategories().subscribe((data: any[]) => {
      this.catogrylst = data;

    });
  }
  fnplusMinus() {

  }
}

